import client from '@/api/client'
import qs from 'qs'
import { callWithRetry } from '@/utils/async'


// poll a given url until there are result then download it
async function downloadFromURL(url) {
    const {data} = await client.get(url, {baseURL: '/'})
    if (!data) {
        throw new Error('not ready yet.')
    }
    return data
}

export async function downloadByPolling(url) {
    return callWithRetry(async () => await downloadFromURL(url))
}
